import { Box, Text, Button } from "@chakra-ui/react";
import { formatLiveCourseDateTime } from "../../redux/actions/actions";
import { useDispatch } from "react-redux";
import { deleteCourse } from "../../redux/api_calls/apiCalls";
import IndividualLiveCourseCard from "./IndividualLiveCourseCard";

export default function AllLiveCourses({ courses, method, loadMoreVisible }) {
  const dispatch = useDispatch()
  console.log(courses);

  const deleteHandler = (id) => {
    console.log("...")
    let updatedCourses = courses.filter((course) => course.id !== id);
    let courseToRemove = courses.find((course) => course.id === id);
    dispatch(deleteCourse(updatedCourses, id, courseToRemove));
  };

  return (
    <Box
      width={["90%", "85%", "80%", "80%"]}
      flexDirection="column"
      justifyContent="space-between"
      alignItems="center"
      d={["none", "none", "none", "none", "flex"]}
      mb="1.5rem"
    >
      <Box d={["none", "none", "none", "none", "flex"]} width="100%" p="1rem">
        <Text
          variant="custom"
          style={{ fontFamily: "Mulish, sans-serif" }}
          width="25%"
        >
          Course Name
        </Text>
        <Text
          variant="custom"
          style={{ fontFamily: "Mulish, sans-serif" }}
          width="21.5%"
          textAlign="center"
        >
          Trainer Name
        </Text>
        <Text
          variant="custom"
          style={{ fontFamily: "Mulish, sans-serif" }}
          width="23.5%"
          textAlign="center"
        >
          Scheduled On
        </Text>
        <Text
          variant="custom"
          style={{ fontFamily: "Mulish, sans-serif" }}
          width="19.5%"
          textAlign="center"
        >
          Duration <span style={{ fontSize: "10px" }}>(in Minutes)</span>
        </Text>
        <Text
          variant="custom"
          style={{ fontFamily: "Mulish, sans-serif" }}
          width="18.5%"
          textAlign="center"
        >
          Actions
        </Text>
      </Box>
      {courses.map((course) => (
        <IndividualLiveCourseCard
          key={course.id}
          image={course.cover_image_url ? course.cover_image_url : null}
          name={course.title}
          trainer_name={course.host_name}
          start_time={formatLiveCourseDateTime(course.start)}
          duration={(Date.parse(course.end) - Date.parse(course.start)) / 60000}
          id={course.id}
          link={course.web_link}
          removeLiveCourse={deleteHandler}
        />
      ))}
      {loadMoreVisible && (
        <Button
          color="#00000099"
          style={{ fontFamily: "Mulish, sans-serif" }}
          fontWeight="700"
          fontSize={["12px", "14px", "16px", "18px"]}
          border="2px solid rgba(0, 0, 0, 0.1)"
          boxShadow="0px 3px 16px rgba(0, 0, 0, 0.1)"
          borderRadius="xl"
          py={["0.5rem", "0.75rem", "1rem", "1.5rem"]}
          px={["0.75rem", "1rem", "1.5rem", "2rem"]}
          m="2rem"
          bg="#ffffff"
          onClick={method}
        >
          Load More...
        </Button>
      )}
    </Box>
  );
}
